import { TPlanType } from '../core/models/iorder-state.model';

const DEFAULT_PARSE_REGEXP = /\{([^\}]+)?\}/g;
/**
 * this is a primitive template engine that can interpolate var inside braces {varName}
 */
export function interpolateStr(tpl: string, data: { [propName: string]: any }, parseRegexp?: RegExp): string {
  const re = parseRegexp || DEFAULT_PARSE_REGEXP;
  let resultTpl = tpl;
  let match;
  // tslint:disable-next-line: no-conditional-assignment
  while ((match = re.exec(resultTpl))) {
    resultTpl = resultTpl.replace(match[0], data[match[1]] || '');
  }
  return resultTpl;
}

export async function encryptSha256(message: string): Promise<string> {
  const msgBuffer = new TextEncoder().encode(message);
  const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map((b) => b.toString(16).padStart(2, '0')).join('');
}

export const uppercaseFirstChars = (str: string): string => {
  const words = str.split(' ');
  for (let i = 0; i < words.length; i++) {
    words[i] = words[i][0].toUpperCase() + words[i].substring(1);
  }
  return words.join(' ');
};

export const planTypeName = (planType: TPlanType): string => {
  switch (planType) {
    case 'starter':
      return 'Starter';
    case 'premium':
      return 'Premium';
    case 'pro':
      return 'Pro';
    case 'hybrid':
      return 'Pro & Premium';
    default:
      return 'Premium';
  }
};

export const planDeviceName = (planType: TPlanType): string => {
  switch (planType) {
    case 'pro':
      return 'Dashcam';
    default:
      return 'Tracker';
  }
};

export const planDevicePreviewImg = (planType: TPlanType): string => {
  switch (planType) {
    case 'pro':
      return 'assets/images/trakview-pro-preview.webp';
    case 'starter':
      return 'assets/images/gps-starter-preview.webp';
    default:
      return 'assets/images/gps-premium-preview.webp';
  }
};

export const planDeviceImg = (planType: TPlanType): string => {
  if (planType === 'pro') {
    return 'assets/images/dashcam.webp';
  } else {
    return 'assets/images/tracker.webp';
  }
};
